import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { PostCreatePage, socialTargetsQueryOptions } from '@/features/social';
import { storeQueryOptions } from '@/features/stores';

export const Route = createFileRoute('/_authed/_active/s/$storeId/social/pinterest/create')({
  staticData: { crumb: 'social:editor.createCrumb' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'social.write');
  },
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.query({
        ...socialTargetsQueryOptions(params.storeId, 'pinterest'),
        staleTime: 'static',
      }),
      context.queryClient.query({ ...storeQueryOptions(params.storeId), staleTime: 'static' }),
    ]).catch(() => undefined),
  component: PostCreatePage,
});
